import { render } from "./FormPessoa.vue?vue&type=template&id=cbb057d4&scoped=true"
import script from "./FormPessoa.vue?vue&type=script&lang=js"
export * from "./FormPessoa.vue?vue&type=script&lang=js"

import "./FormPessoa.vue?vue&type=style&index=0&id=cbb057d4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbb057d4"]])

export default __exports__